import { render } from "./PlatformGovernanceDetailsView.vue?vue&type=template&id=43eec287"
import script from "./PlatformGovernanceDetailsView.vue?vue&type=script&lang=js"
export * from "./PlatformGovernanceDetailsView.vue?vue&type=script&lang=js"

import "./PlatformGovernanceDetailsView.vue?vue&type=style&index=0&id=43eec287&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__